module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_1_m.d75b92972cadad0c7cb6351989910cc0.png";